import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, renderSlot as _renderSlot, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "sidebar__brand-logo"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
  key: 1,
  class: "ri-target-line"
};
const _hoisted_4 = {
  class: "sidebar__brand-info"
};
const _hoisted_5 = {
  class: "sidebar__brand-name"
};
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", {
  class: "sidebar__brand-sub"
}, "Workspace", -1);
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", {
  class: "ri-close-line"
}, null, -1);
const _hoisted_8 = [_hoisted_7];
const _hoisted_9 = {
  class: "sidebar__menu"
};
const _hoisted_10 = {
  class: "sidebar__profile",
  type: "button"
};
const _hoisted_11 = {
  class: "sidebar__profile-avatar-wrap"
};
const _hoisted_12 = ["src"];
const _hoisted_13 = {
  key: 1,
  class: "sidebar__profile-initial"
};
const _hoisted_14 = ["title"];
const _hoisted_15 = {
  class: "sidebar__profile-info"
};
const _hoisted_16 = {
  class: "sidebar__profile-name"
};
const _hoisted_17 = {
  class: "sidebar__profile-role"
};
const _hoisted_18 = {
  class: "ri-more-2-fill sidebar__profile-more"
};
const _hoisted_19 = {
  class: "sidebar-profile-popper__header"
};
const _hoisted_20 = {
  class: "sidebar-profile-popper__name"
};
const _hoisted_21 = {
  class: "sidebar-profile-popper__email"
};
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", {
  class: "ri-user-line"
}, null, -1);
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", null, "View profile", -1);
const _hoisted_24 = /*#__PURE__*/_createElementVNode("i", {
  class: "ri-notification-3-line"
}, null, -1);
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", null, "Notifications", -1);
const _hoisted_26 = {
  key: 0,
  class: "sidebar-profile-item__badge"
};
const _hoisted_27 = {
  class: "sidebar-profile-item"
};
const _hoisted_28 = {
  class: "sidebar-profile-item"
};
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", {
  class: "sidebar-profile-item sidebar-profile-item--danger"
}, [/*#__PURE__*/_createElementVNode("i", {
  class: "ri-logout-box-r-line"
}), /*#__PURE__*/_createElementVNode("span", null, "Sign out")], -1);
const _hoisted_30 = {
  class: "sidebar__footer"
};
const _hoisted_31 = {
  style: {
    "min-height": "100%"
  }
};
const _hoisted_32 = {
  class: "mobile-bottom-nav d-print-none"
};
const _hoisted_33 = /*#__PURE__*/_createElementVNode("i", {
  class: "ri-home-5-line"
}, null, -1);
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", null, "Home", -1);
const _hoisted_35 = /*#__PURE__*/_createElementVNode("i", {
  class: "ri-slideshow-line"
}, null, -1);
const _hoisted_36 = /*#__PURE__*/_createElementVNode("span", null, "Projects", -1);
const _hoisted_37 = /*#__PURE__*/_createElementVNode("i", {
  class: "ri-time-line"
}, null, -1);
const _hoisted_38 = /*#__PURE__*/_createElementVNode("span", null, "Time", -1);
const _hoisted_39 = /*#__PURE__*/_createElementVNode("i", {
  class: "ri-calendar-check-line"
}, null, -1);
const _hoisted_40 = /*#__PURE__*/_createElementVNode("span", null, "Leave", -1);
const _hoisted_41 = /*#__PURE__*/_createElementVNode("i", {
  class: "ri-menu-fold-line"
}, null, -1);
const _hoisted_42 = /*#__PURE__*/_createElementVNode("span", null, "More", -1);
const _hoisted_43 = [_hoisted_41, _hoisted_42];
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", {
  class: "wn-banner__sparkles"
}, [/*#__PURE__*/_createElementVNode("i", {
  class: "ri-sparkling-2-fill"
}), /*#__PURE__*/_createElementVNode("i", {
  class: "ri-sparkling-fill wn-banner__sparkle wn-banner__sparkle--a"
}), /*#__PURE__*/_createElementVNode("i", {
  class: "ri-sparkling-fill wn-banner__sparkle wn-banner__sparkle--b"
})], -1);
const _hoisted_45 = /*#__PURE__*/_createElementVNode("span", {
  class: "wn-banner__pill"
}, "What's new", -1);
const _hoisted_46 = /*#__PURE__*/_createElementVNode("h2", {
  class: "wn-banner__title"
}, "Welcome to the new look ✨", -1);
const _hoisted_47 = /*#__PURE__*/_createElementVNode("p", {
  class: "wn-banner__sub"
}, "A fresh, focused redesign across the entire app.", -1);
const _hoisted_48 = /*#__PURE__*/_createElementVNode("i", {
  class: "ri-close-line"
}, null, -1);
const _hoisted_49 = [_hoisted_48];
const _hoisted_50 = {
  class: "wn-body"
};
const _hoisted_51 = /*#__PURE__*/_createElementVNode("p", {
  class: "wn-intro"
}, [/*#__PURE__*/_createTextVNode(" We've completely refreshed Tracker with a new "), /*#__PURE__*/_createElementVNode("strong", null, "indigo & violet"), /*#__PURE__*/_createTextVNode(" theme, cleaner tables, polished forms and a redesigned sidebar. Most every page you use day to day has been reworked for clarity and consistency. ")], -1);
const _hoisted_52 = /*#__PURE__*/_createElementVNode("div", {
  class: "wn-grid"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "wn-card"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "wn-card__icon"
}, [/*#__PURE__*/_createElementVNode("i", {
  class: "ri-palette-line"
})]), /*#__PURE__*/_createElementVNode("span", {
  class: "wn-card__title"
}, "Brand new theme"), /*#__PURE__*/_createElementVNode("span", {
  class: "wn-card__hint"
}, "Indigo gradients, modern typography, full dark-mode support.")]), /*#__PURE__*/_createElementVNode("div", {
  class: "wn-card"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "wn-card__icon"
}, [/*#__PURE__*/_createElementVNode("i", {
  class: "ri-table-line"
})]), /*#__PURE__*/_createElementVNode("span", {
  class: "wn-card__title"
}, "Cleaner tables"), /*#__PURE__*/_createElementVNode("span", {
  class: "wn-card__hint"
}, "Sticky headers, status pills and a polished pagination bar.")]), /*#__PURE__*/_createElementVNode("div", {
  class: "wn-card"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "wn-card__icon"
}, [/*#__PURE__*/_createElementVNode("i", {
  class: "ri-input-cursor-move"
})]), /*#__PURE__*/_createElementVNode("span", {
  class: "wn-card__title"
}, "Polished forms"), /*#__PURE__*/_createElementVNode("span", {
  class: "wn-card__hint"
}, "Themed inputs, file chips and gradient-banded modals.")]), /*#__PURE__*/_createElementVNode("div", {
  class: "wn-card"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "wn-card__icon"
}, [/*#__PURE__*/_createElementVNode("i", {
  class: "ri-layout-left-2-line"
})]), /*#__PURE__*/_createElementVNode("span", {
  class: "wn-card__title"
}, "Redesigned sidebar"), /*#__PURE__*/_createElementVNode("span", {
  class: "wn-card__hint"
}, "Brand header, profile widget and an active-page accent.")])], -1);
const _hoisted_53 = {
  class: "wn-note"
};
const _hoisted_54 = /*#__PURE__*/_createElementVNode("span", null, " Dark mode is now the default. You can switch any time from your profile menu in the sidebar. ", -1);
const _hoisted_55 = /*#__PURE__*/_createElementVNode("i", {
  class: "ri-arrow-right-line"
}, null, -1);
const _hoisted_56 = /*#__PURE__*/_createElementVNode("span", null, "Got it, let's go", -1);
const _hoisted_57 = [_hoisted_55, _hoisted_56];
import { computed, onMounted, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import usePlanPrice from '@/composable/plan-price';
import useAuth from '@/composable/auth';
import useLayouts from '@/composable/layout';
import useNotifications from '@/composable/notifications';
const WHATS_NEW_KEY = 'tracker-whats-new:2026.05';
export default {
  __name: 'Admin',
  setup(__props) {
    const {
      tenantInfo
    } = usePlanPrice();
    const {
      isCollapse,
      toggleSidebar
    } = useLayouts();
    const {
      LogoutUser
    } = useAuth();
    const {
      notifyUnreadCount
    } = useNotifications();
    const store = useStore();
    const drawerOpen = ref(false);
    const route = useRoute();
    const currentUser = computed(() => store.getters['auth/getCurrentUser'] || {});
    const isDark = ref(document.documentElement.getAttribute('data-bs-theme') === 'dark');
    const isFullscreen = ref(false);

    // "What's new" announcement — bump the suffix when there's a new release
    // to re-show the modal to users who already dismissed previous ones.
    const showWhatsNew = ref(false);
    function dismissWhatsNew() {
      try {
        localStorage.setItem(WHATS_NEW_KEY, '1');
      } catch (_) {/* ignore quota errors */}
      showWhatsNew.value = false;
    }
    const unreadCount = computed(() => Number(notifyUnreadCount.value) || 0);
    const unreadDisplay = computed(() => unreadCount.value > 99 ? '99+' : String(unreadCount.value));
    function toggleTheme() {
      const newTheme = isDark.value ? 'light' : 'dark';
      document.documentElement.setAttribute('data-bs-theme', newTheme);
      document.documentElement.classList.remove('light', 'dark');
      document.documentElement.classList.add(newTheme);
      localStorage.setItem('theme', newTheme);
      isDark.value = newTheme === 'dark';
    }
    function toggleFullscreen() {
      document.body.classList.toggle('fullscreen-enable');
      const inFullscreen = document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement;
      if (!inFullscreen) {
        const el = document.documentElement;
        if (el.requestFullscreen) el.requestFullscreen();else if (el.mozRequestFullScreen) el.mozRequestFullScreen();else if (el.webkitRequestFullscreen) el.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
      } else {
        if (document.exitFullscreen) document.exitFullscreen();else if (document.mozCancelFullScreen) document.mozCancelFullScreen();else if (document.webkitCancelFullScreen) document.webkitCancelFullScreen();
      }
    }
    function handleLogout() {
      LogoutUser();
    }
    function syncFullscreenState() {
      isFullscreen.value = Boolean(document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement);
    }
    onMounted(() => {
      document.addEventListener('fullscreenchange', syncFullscreenState);
      document.addEventListener('webkitfullscreenchange', syncFullscreenState);
      document.addEventListener('mozfullscreenchange', syncFullscreenState);
      try {
        if (localStorage.getItem(WHATS_NEW_KEY) !== '1') {
          // Brief delay so the layout has settled before the dialog pops in.
          setTimeout(() => {
            showWhatsNew.value = true;
          }, 600);
        }
      } catch (_) {/* localStorage unavailable */}
    });
    watch(() => route.path, () => {
      drawerOpen.value = false;
    });
    function goToExternalSite() {
      if (tenantInfo?.value?.website) {
        window.open(tenantInfo.value.website, '_blank');
      }
    }
    function isRouteActive(prefix) {
      return route.path === prefix || route.path.startsWith(prefix + '/');
    }
    return (_ctx, _cache) => {
      const _component_Menu = _resolveComponent("Menu");
      const _component_el_scrollbar = _resolveComponent("el-scrollbar");
      const _component_router_link = _resolveComponent("router-link");
      const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
      const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
      const _component_el_dropdown = _resolveComponent("el-dropdown");
      const _component_el_aside = _resolveComponent("el-aside");
      const _component_el_main = _resolveComponent("el-main");
      const _component_el_container = _resolveComponent("el-container");
      const _component_b_modal = _resolveComponent("b-modal");
      return _openBlock(), _createBlock(_component_el_container, {
        class: "layout-container-demo"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_container, {
          class: "app-body"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_aside, {
            class: _normalizeClass(["d-print-none sidebar", {
              'sidebar--open': drawerOpen.value,
              'sidebar--collapsed': _unref(isCollapse)
            }]),
            width: "auto"
          }, {
            default: _withCtx(() => [_createElementVNode("header", {
              class: "sidebar__brand",
              onClick: goToExternalSite
            }, [_createElementVNode("div", _hoisted_1, [_unref(tenantInfo)?.logo ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: _unref(tenantInfo).logo,
              alt: ""
            }, null, 8, _hoisted_2)) : (_openBlock(), _createElementBlock("i", _hoisted_3))]), _withDirectives(_createElementVNode("div", _hoisted_4, [_createElementVNode("h2", _hoisted_5, _toDisplayString(_unref(tenantInfo)?.tenant_name || 'Tracker'), 1), _hoisted_6], 512), [[_vShow, !_unref(isCollapse)]])]), _createElementVNode("button", {
              class: "sidebar__close d-print-none",
              type: "button",
              "aria-label": "Close menu",
              onClick: _cache[0] || (_cache[0] = $event => drawerOpen.value = false)
            }, _hoisted_8), _createElementVNode("div", _hoisted_9, [_createVNode(_component_el_scrollbar, null, {
              default: _withCtx(() => [_createVNode(_component_Menu)]),
              _: 1
            })]), _createVNode(_component_el_dropdown, {
              trigger: "click",
              placement: "top-end",
              "popper-class": "sidebar-profile-popper"
            }, {
              dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_19, [_createElementVNode("span", _hoisted_20, _toDisplayString(currentUser.value?.fullname || 'User'), 1), _createElementVNode("span", _hoisted_21, _toDisplayString(currentUser.value?.email || ''), 1)]), _createVNode(_component_el_dropdown_item, null, {
                  default: _withCtx(() => [_createVNode(_component_router_link, {
                    to: "/profile",
                    class: "sidebar-profile-item"
                  }, {
                    default: _withCtx(() => [_hoisted_22, _hoisted_23]),
                    _: 1
                  })]),
                  _: 1
                }), _createVNode(_component_el_dropdown_item, null, {
                  default: _withCtx(() => [_createVNode(_component_router_link, {
                    to: "/profile/notifications",
                    class: "sidebar-profile-item"
                  }, {
                    default: _withCtx(() => [_hoisted_24, _hoisted_25, unreadCount.value > 0 ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(unreadDisplay.value), 1)) : _createCommentVNode("", true)]),
                    _: 1
                  })]),
                  _: 1
                }), _createVNode(_component_el_dropdown_item, {
                  onClick: toggleFullscreen
                }, {
                  default: _withCtx(() => [_createElementVNode("span", _hoisted_27, [_createElementVNode("i", {
                    class: _normalizeClass(isFullscreen.value ? 'ri-fullscreen-exit-line' : 'ri-fullscreen-line')
                  }, null, 2), _createElementVNode("span", null, _toDisplayString(isFullscreen.value ? 'Exit fullscreen' : 'Fullscreen'), 1)])]),
                  _: 1
                }), _createVNode(_component_el_dropdown_item, {
                  onClick: toggleTheme
                }, {
                  default: _withCtx(() => [_createElementVNode("span", _hoisted_28, [_createElementVNode("i", {
                    class: _normalizeClass(isDark.value ? 'ri-sun-line' : 'ri-moon-line')
                  }, null, 2), _createElementVNode("span", null, _toDisplayString(isDark.value ? 'Light mode' : 'Dark mode'), 1)])]),
                  _: 1
                }), _createVNode(_component_el_dropdown_item, {
                  divided: "",
                  onClick: handleLogout
                }, {
                  default: _withCtx(() => [_hoisted_29]),
                  _: 1
                })]),
                _: 1
              })]),
              default: _withCtx(() => [_createElementVNode("button", _hoisted_10, [_createElementVNode("span", _hoisted_11, [currentUser.value?.image ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: currentUser.value.image,
                alt: "",
                class: "sidebar__profile-avatar"
              }, null, 8, _hoisted_12)) : (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(currentUser.value?.fullname?.charAt(0) || '?'), 1)), unreadCount.value > 0 ? (_openBlock(), _createElementBlock("span", {
                key: 2,
                class: "sidebar__profile-badge",
                title: `${unreadCount.value} unread notifications`
              }, _toDisplayString(unreadDisplay.value), 9, _hoisted_14)) : _createCommentVNode("", true)]), _withDirectives(_createElementVNode("span", _hoisted_15, [_createElementVNode("span", _hoisted_16, _toDisplayString(currentUser.value?.fullname || 'User'), 1), _createElementVNode("span", _hoisted_17, _toDisplayString(currentUser.value?.role || ''), 1)], 512), [[_vShow, !_unref(isCollapse)]]), _withDirectives(_createElementVNode("i", _hoisted_18, null, 512), [[_vShow, !_unref(isCollapse)]])])]),
              _: 1
            }), _createElementVNode("footer", _hoisted_30, [_createElementVNode("button", {
              class: "sidebar__collapse-btn",
              type: "button",
              onClick: _cache[1] || (_cache[1] = $event => _unref(toggleSidebar)(!_unref(isCollapse)))
            }, [_createElementVNode("i", {
              class: _normalizeClass(_unref(isCollapse) ? 'ri-arrow-right-s-line' : 'ri-arrow-left-s-line')
            }, null, 2), _withDirectives(_createElementVNode("span", null, "Collapse", 512), [[_vShow, !_unref(isCollapse)]])])])]),
            _: 1
          }, 8, ["class"]), drawerOpen.value ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "drawer-backdrop d-print-none",
            onClick: _cache[2] || (_cache[2] = $event => drawerOpen.value = false)
          })) : _createCommentVNode("", true), _createVNode(_component_el_main, {
            class: "main-scroll"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_31, [_renderSlot(_ctx.$slots, "default")])]),
            _: 3
          })]),
          _: 3
        }), _createElementVNode("nav", _hoisted_32, [_createVNode(_component_router_link, {
          to: "/dashboard",
          class: _normalizeClass(["mobile-bottom-nav__item", {
            'is-active': isRouteActive('/dashboard')
          }])
        }, {
          default: _withCtx(() => [_hoisted_33, _hoisted_34]),
          _: 1
        }, 8, ["class"]), _createVNode(_component_router_link, {
          to: "/projects",
          class: _normalizeClass(["mobile-bottom-nav__item", {
            'is-active': isRouteActive('/projects')
          }])
        }, {
          default: _withCtx(() => [_hoisted_35, _hoisted_36]),
          _: 1
        }, 8, ["class"]), _createVNode(_component_router_link, {
          to: "/time-tracking",
          class: _normalizeClass(["mobile-bottom-nav__item", {
            'is-active': isRouteActive('/time-tracking')
          }])
        }, {
          default: _withCtx(() => [_hoisted_37, _hoisted_38]),
          _: 1
        }, 8, ["class"]), _createVNode(_component_router_link, {
          to: "/leaves/list",
          class: _normalizeClass(["mobile-bottom-nav__item", {
            'is-active': isRouteActive('/leaves')
          }])
        }, {
          default: _withCtx(() => [_hoisted_39, _hoisted_40]),
          _: 1
        }, 8, ["class"]), _createElementVNode("button", {
          type: "button",
          class: "mobile-bottom-nav__item mobile-bottom-nav__more",
          onClick: _cache[3] || (_cache[3] = $event => drawerOpen.value = true)
        }, _hoisted_43)]), _createVNode(_component_b_modal, {
          modelValue: showWhatsNew.value,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => showWhatsNew.value = $event),
          centered: "",
          "hide-header": "",
          "hide-footer": "",
          "no-close-on-backdrop": "",
          "modal-class": "wn-modal",
          "body-class": "wn-modal__body"
        }, {
          default: _withCtx(() => [_createElementVNode("div", {
            class: "wn-banner"
          }, [_hoisted_44, _hoisted_45, _hoisted_46, _hoisted_47, _createElementVNode("button", {
            type: "button",
            class: "wn-banner__close",
            "aria-label": "Close",
            onClick: dismissWhatsNew
          }, _hoisted_49)]), _createElementVNode("div", _hoisted_50, [_hoisted_51, _hoisted_52, _createElementVNode("div", _hoisted_53, [_createElementVNode("i", {
            class: _normalizeClass(isDark.value ? 'ri-moon-line' : 'ri-sun-line')
          }, null, 2), _hoisted_54])]), _createElementVNode("div", {
            class: "wn-actions"
          }, [_createElementVNode("button", {
            type: "button",
            class: "wn-btn wn-btn--ghost",
            onClick: dismissWhatsNew
          }, " Maybe later "), _createElementVNode("button", {
            type: "button",
            class: "wn-btn wn-btn--primary",
            onClick: dismissWhatsNew
          }, _hoisted_57)])]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 3
      });
    };
  }
};